<template>
    <section>
        <nav class="navbar navbar-expand-lg fixed-top" :class="{ 'navbar-mobile': isMobile }">
            <button
                v-if="!isMobile"
                class="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                :data-bs-target="`#${navbarId}`"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
                @click="showCollapse = !showCollapse"
            >
                <span class="navbar-toggler-icon"></span>
            </button>
            <a class="navbar-brand brand-block" @click="homePage">
                <span class="brand-logo-wrap" aria-hidden="true">
                    <img :src="logo" alt="" class="brand-logo" />
                </span>
                <span class="brand-name">OTFM</span>
            </a>

            <div
                v-if="!isMobile"
                class="collapse navbar-collapse"
                :class="{ show: showCollapse }"
                :id="navbarId"
                @click="showCollapse = !showCollapse"
            >
                <ul class="navbar-nav mr-auto">
                    <li class="nav-item active">
                        <a class="nav-link" @click="homePage">Home</a>
                    </li>
                    <li class="nav-item">
                        <a v-if="showAdminNav" class="nav-link" @click="createUser">Benutzerverwaltung</a>
                    </li>
                    <li class="nav-item">
                        <a v-if="showAdminNav" class="nav-link" @click="adminSystem">Systemverwaltung</a>
                    </li>
                    <li class="nav-item">
                        <a v-if="showAdminNav" class="nav-link" @click="adminStats">Statistik</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" @click="logOut">Ausloggen{{ logoutUserLabel }}</a>
                    </li>
                </ul>
            </div>
        </nav>
        <confirm-dialogue ref="confirmDialogue" />
    </section>
</template>
  
<script>
import logo from '@/assets/logo.png';
import { isMobileBuild } from '@/utils/platform';
import ConfirmDialogue from './ConfirmDialogue.vue';

export default {
    components: { ConfirmDialogue },
    data() {
        return {
            logo,
            userRole: this.$store.state.auth.user.role,
            showCollapse: false,
            navbarId: "navbarSupportedContent"
        };
    },
    computed: {
        isMobile() {
            return isMobileBuild();
        },
        showAdminNav() {
            return this.userRole === 'administrator' && !this.isMobile;
        },
        logoutUserLabel() {
            const login = this.$store.state.auth.user?.login;
            return login ? ` (${login})` : '';
        },
    },
    mounted() {
        window.addEventListener("click", this.handleClickOutside);
    },
    beforeUnmount() {
        window.removeEventListener("click", this.handleClickOutside);
    },
    methods: {
        handleClickOutside(event) {
            const navbar = this.$el.querySelector(".navbar");
            if (!navbar.contains(event.target)) {
                this.showCollapse = false;
            }
        },
        logOut() {
            this.confirmAndLogOut();
        },
        async confirmAndLogOut() {
            const ok = await this.$refs.confirmDialogue.show({
                title: 'Ausloggen',
                message: 'Möchten Sie sich wirklich abmelden?',
                okButton: 'Ausloggen',
                cancelButton: 'Abbrechen',
            });
            if (!ok) {
                return;
            }
            this.$store.dispatch("auth/logout");
            this.$router.push("/login");
        },
        homePage() {
            this.$router.push("/home");
        },
        createUser() {
            this.$router.push("/create_user");
        },
        adminSystem() {
            this.$router.push("/admin_system");
        },
        adminStats() {
            this.$router.push("/admin_stats");
        }
    }
};
</script>
  

<style scoped>
header {
    display: flex;
    min-width: 100vw;
    min-height: 1vh;
    justify-content: center;
    align-items: center;
    background-color: #264271;
    color: white;
}

h1 {
    font-size: 2.4rem;
    padding: 1rem;
}

a {
    cursor: pointer;
}

.nav-link {
    margin: 0 1rem 0 1rem;
    font-size: 1.1rem;
    border-radius: 10px;
    padding-top: 0.2rem;
    padding-bottom: 0.2rem;
}

.nav-link:hover {
    background-color: #315492;
    transition: all 0.2s ease-in-out;
}

.navbar {
    background-color: #264271;
    padding: 0.5rem 1.35rem;
    min-height: unset;
}

.navbar a {
    color: white;
}

.navbar button {
    background-color: white;
    padding: 0.2rem 0.45rem;
}

nav button:focus {
    box-shadow: 0 0 5px 5px #315492;
}

.brand-block {
    display: flex;
    align-items: center;
    gap: 0.6rem;
    margin-bottom: 0;
    padding-top: 0;
    padding-bottom: 0;
}

.brand-logo-wrap {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    width: 2.5rem;
    height: 1.75rem;
    overflow: hidden;
    background-color: #fff;
    border-radius: 0.35rem;
    padding-top: 0.24rem;
    box-sizing: border-box;
    flex-shrink: 0;
}

.brand-logo {
    width: 2rem;
    height: auto;
    max-width: none;
    display: block;
}

.brand-name {
    font-size: 1.75rem;
    line-height: 1.2;
}

.navbar-mobile {
    padding-top: calc(0.5rem + env(safe-area-inset-top, 0px));
    min-height: var(--app-header-height);
}

.navbar-mobile .brand-block {
    order: 1;
    margin-left: 0;
    margin-right: auto;
}

@media (max-width: 991.98px) {
    .navbar {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        padding: 0.5rem 1rem;
    }

    .navbar-mobile {
        padding-top: calc(0.5rem + env(safe-area-inset-top, 0px));
    }

    .navbar-toggler {
        order: 1;
        margin-right: 0;
        padding: 0.15rem 0.38rem;
        font-size: 1rem;
        border-radius: 0.35rem;
        line-height: 1;
        height: 1.75rem;
        width: 2.1rem;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .navbar-toggler-icon {
        width: 1.15em;
        height: 1.15em;
    }

    .brand-block {
        order: 2;
        margin-left: auto;
        margin-right: 0;
    }

    .navbar-collapse {
        order: 3;
        width: 100%;
    }
}

@media (max-width: 768px) {
    .brand-logo-wrap {
        width: 2.2rem;
        height: 1.55rem;
        padding-top: 0.2rem;
    }

    .brand-logo {
        width: 1.75rem;
    }

    .brand-name {
        font-size: 1.55rem;
    }

    .navbar-toggler {
        padding: 0.12rem 0.34rem;
        font-size: 0.95rem;
        height: 1.55rem;
        width: 1.85rem;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .navbar-toggler-icon {
        width: 1.05em;
        height: 1.05em;
    }
}

.collapse {}
</style>




<!-- 
<template>
    <section>
        <nav class="navbar navbar-expand-lg fixed-top">
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <a class="navbar-brand brand-name" @click="homePage">OTFM</a>

            <div class="collapse navbar-collapse" id="navbarSupportedContent" >
                <ul class="navbar-nav mr-auto">
                    <li class="nav-item active">
                        <a class="nav-link" @click="homePage">Home
                        </a>
                    </li>
                    <li class="nav-item">
                        <a v-if="userRole === 'administrator'" class="nav-link" @click="createUser">Manage Users</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" @click="logOut">LogOut</a>
                    </li>
                </ul>
            </div>
        </nav>
    </section>
</template>

<script>

export default {
    data() {
        return {
            userRole: this.$store.state.auth.user.role,
            showCollapse: false,
        };
    },

    methods: {
        logOut() {
            this.$store.dispatch('auth/logout');
            this.$router.push('/login');
        },
        homePage() {
            this.$router.push('/home');
        },
        createUser() {
            this.$router.push('/create_user');
        },
    },
};
</script>
 -->